export * from '@primeuix/themes/material/datatable';
export { default } from '@primeuix/themes/material/datatable';
